/* MediGel — Kaching Bundles bridge (visual only, no cart wiring).
   The Kaching app block is the real variant selector; the reference cover
   card and CTA label are design elements. This bridge mirrors whichever
   Kaching bar is selected into:
   - the cover card's ×N quantity + price ([data-medigel-cover-qty/-price])
   - the CTA label total ("Checkout Securely · $TOTAL"), which now reflects
     Kaching's OWN pricing: selected tier total + Kaching's checkbox upsell
     (the Machine-Washable Cover) when it is checked.
   Kaching's bars are Vue-rendered — no change events escape its form — so
   selection AND the cover-upsell checkbox (a <span>, not an <input>, whose
   checked-state is a `--selected` class flip) are observed via class flips.
   The reference tier stack (visual-only) can also drive the cover/CTA via
   medigel.js + the hero scaffold; the last UI the buyer touched wins. */
(function () {
  'use strict';
  if (window.__medigelKachingInit) return;
  window.__medigelKachingInit = true;

  function money(cents) {
    var v = Math.round(cents) / 100;
    var s = Math.round(v) === v ? String(v) : v.toFixed(2);
    var parts = s.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + parts.join('.');
  }

  function init() {
    var hero = document.querySelector('[data-medigel-hero]');
    if (!hero) return;
    var coverEach = parseInt(hero.dataset.coverEach || '0', 10); // cents
    var driving = false; // true while Kaching is the last-touched tier UI

    function selectedBar() {
      // scoped to __bars: the checkbox-upsell row also carries bar--selected
      return hero.querySelector('.kaching-bundles__bars .kaching-bundles__bar--selected');
    }
    function addOnCents() {
      // Kaching's checkbox upsell (the REAL add-on that hits checkout). Its
      // "checkbox" is a <span>; checked-state is the --selected class (on the
      // checkbox span and the upsell's .kaching-bundles__bar). Its price element
      // already carries the FULL add-on total for the selected tier qty
      // (x1 $14 / x2 $28 / x4 $56 — Kaching scales it), so read it live and add
      // it as-is. Returns 0 when unchecked or absent.
      var up = hero.querySelector('.kaching-bundles__checkbox-upsells');
      if (!up) return 0;
      var checked = up.querySelector('.kaching-bundles__bar--selected') ||
                    up.querySelector('.kaching-bundles__checkbox-upsells__checkbox--selected');
      if (!checked) return 0;
      var priceEl = up.querySelector('.kaching-bundles__bar-price');
      var pm = priceEl && priceEl.textContent.match(/[\d,]+\.?\d*/);
      var v = pm ? parseFloat(pm[0].replace(/,/g, '')) : 0;
      return Math.round(v * 100);
    }
    function sync() {
      var sel = selectedBar();
      if (!sel) return;
      // bar titles are "Get N" (Kaching admin copy) — N = cushion count
      var titleEl = sel.querySelector('.kaching-bundles__bar-title');
      var tm = titleEl && titleEl.textContent.match(/\d+/);
      var qty = tm ? parseInt(tm[0], 10) : 1;
      hero.querySelectorAll('[data-medigel-cover-qty]').forEach(function (el) { el.textContent = qty; });
      var coverPrice = hero.querySelector('[data-medigel-cover-price]');
      if (coverPrice) coverPrice.textContent = '+' + money(coverEach * qty);
      // CTA total from Kaching's own pricing: per-unit price × N, plus the
      // Kaching cover-upsell total when its checkbox is checked (read live).
      var priceEl = sel.querySelector('.kaching-bundles__bar-price');
      var pm = priceEl && priceEl.textContent.match(/[\d,]+\.?\d*/);
      var unit = pm ? parseFloat(pm[0].replace(/,/g, '')) : 0;
      var cents = Math.round(unit * 100) * qty;
      if (cents > 0) {
        cents += addOnCents();
        var span = hero.querySelector('.product-form__submit > span');
        if (span) span.textContent = 'Checkout Securely · ' + money(cents);
      }
    }

    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (!t.closest) continue;
        // Kaching tier bar selected → Kaching becomes the driving tier UI
        if (t.classList && t.classList.contains('kaching-bundles__bar') &&
            t.closest('.kaching-bundles__bars')) {
          driving = true;
          setTimeout(sync, 0); // after Kaching finishes its own DOM updates
          return;
        }
        // Kaching cover-upsell checkbox toggled (checked-state is a --selected
        // class flip inside .kaching-bundles__checkbox-upsells) → re-total
        if (t.closest('.kaching-bundles__checkbox-upsells')) {
          driving = true;
          setTimeout(sync, 0);
          return;
        }
      }
    }).observe(hero, { attributes: true, attributeFilter: ['class'], subtree: true });

    /* Registered at DOMContentLoaded — after the scaffold's parse-time click
       listener — so on a cover toggle this setTimeout lands AFTER the
       scaffold's tier-based CTA update and re-imposes the Kaching total. */
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('[data-medigel-tier]')) { driving = false; return; }
      if (driving && e.target.closest('[data-medigel-cover]')) setTimeout(sync, 0);
    });

    /* Load-order: this defer script inits BEFORE DOMContentLoaded, but the
       scaffold + medigel.js paint the tier-stack total ON DOMContentLoaded —
       so the boot sync must also run just after that event (and again at
       700ms for a late Kaching hydration the observer might miss). */
    var boot = function () { if (selectedBar()) { driving = true; sync(); } };
    boot();
    document.addEventListener('DOMContentLoaded', function () { setTimeout(boot, 0); });
    setTimeout(boot, 700);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
